/**
 * Created by Carsten Bühler
 * User: c.buehler on 01.09.2016
 * Copyright: xdot GmbH 2015
 */

import { RemoteDataActions } from 'plugin/liferay-widgets-react-web';
import ReferenceValueWebApi from '../webapi/ReferenceValueWebApi';
import { ClassNames } from '../constants/Constants';

const className = ClassNames.ReferenceValue;

export default {
    getReferenceValuesByDataTypeNotExpired: (name, query) => RemoteDataActions.list(name, className, query, ReferenceValueWebApi.getReferenceValuesByDataTypeNotExpired),
    remove: (name, query) => RemoteDataActions.remove(name, className)
};



// WEBPACK FOOTER //
// ./js/actions/ReferenceValueActions.js